var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",attrs:{"muted":"","loop":"","autoplay":"autoplay","src":_vm.src},domProps:{"muted":true}})}
var staticRenderFns = []

export { render, staticRenderFns }